import { apiFetch } from "../utils/api";

const BASE = "/api/planet";

async function parse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data.detail;
    const msg =
      typeof detail === "string"
        ? detail
        : Array.isArray(detail)
          ? detail.map((d) => d.msg || JSON.stringify(d)).join("; ")
          : data.message || "请求失败";
    throw new Error(msg);
  }
  return data;
}

export function planetGet(path) {
  return apiFetch(`${BASE}${path}`).then(parse);
}

export function planetPost(path, body) {
  return apiFetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then(parse);
}

export function planetPut(path, body) {
  return apiFetch(`${BASE}${path}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then(parse);
}

export function planetDelete(path) {
  return apiFetch(`${BASE}${path}`, { method: "DELETE" }).then(parse);
}

export async function planetUpload(userId, file) {
  const form = new FormData();
  form.append("user_id", String(userId));
  form.append("file", file);
  const res = await apiFetch(`${BASE}/upload`, { method: "POST", body: form });
  return parse(res);
}

export function getUserId() {
  return Number(localStorage.getItem("user_id") || 0);
}
